'use strict';
import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/takeUntil';
import {AvatarColors} from '../../core-utilities/domain/AvatarColors';
import {getDomainLink} from '../../core-utilities/domain/ReduxUtils';
import {observeNewOnScope, observeOnAttributes, eventToObservable} from '../../core-utilities/rx-utils';
import {SCOPE_DESTROY} from '../../config/constants/view-events';
import template from './avatar.html';


AvatarDirective.$inject = [
];

AvatarController.$inject = [
  '$scope',
  '$attrs',
  '$element',
];

export function AvatarDirective() {
  return {
    restrict: 'E',
    template: template,
    scope: {
      model: '<',
      targetWidth: '=?',
      targetHeight: '=?',
      cropTarget: '@'
    },
    controllerAs: 'avatar',
    bindToController: true,
    controller: AvatarController
  }
}

function AvatarController(
  $scope,
  $attrs,
  $element,
) {
  const vm = this;
  let placeholderText = '-';
  vm.showAvatar = showAvatar;
  vm.setAvatarUrl = setAvatarUrl;
  vm.getAvatarText = getAvatarText;
  vm.getAvatarColor = getAvatarColor;
  vm.getAvatarFontColor = getAvatarFontColor;

  $scope.$evalAsync(init);

  function init() {
    if ($attrs.placeholderText) {
      placeholderText = $attrs.placeholderText;
    }

    const leave$ = eventToObservable($scope, SCOPE_DESTROY);
    const placeholderTitle = $attrs.placeholderTitle;
    const titlePlaceholder$ = isString(placeholderTitle) && placeholderTitle.charAt(0) === '{'
      ? observeOnAttributes($attrs, 'placeholderTitle')
      : Observable.of(placeholderTitle);

    const title$ = Observable.combineLatest(
      titlePlaceholder$,
      observeNewOnScope($scope, 'avatar.model.toString()'),
      (placeholder, title) => title || placeholder
    )
      .takeUntil(leave$)
      .distinctUntilChanged();

    const avatar$ = observeNewOnScope($scope, 'avatar.model.$getLink("avatar").id')
      .takeUntil(leave$)
      .distinctUntilChanged()
      .switchMap(getAvatar);

    title$.subscribe(showTitle);

    avatar$.subscribe(showAvatar);
  }

  function getAvatar() {
    return vm.model ? getDomainLink(vm.model, 'avatar') : Promise.resolve(null);
  }

  /**
   * TODO: support placeholder title. Use-case: task assignment is null - show Unassigned
   * @param {String} title
   */
  function showTitle(title) {
    $element.attr('title', isString(title) ? title : '');
  }

  function showAvatar(file) {
    $scope.$evalAsync(() => {
      vm.file = file;
    });
  }

  function setAvatarUrl(url) {
    $scope.$evalAsync(() => {
      vm.placeholderUrl = url;
    })
  }

  function getAvatarText() {
    if (vm.model)
      return isFunction(vm.model.getAvatarInitials) ? vm.model.getAvatarInitials() : placeholderText;
    else
      return placeholderText;
  }

  function getAvatarColor() {
    if (vm.model)
      return isFunction(vm.model.getAvatarColor) ? vm.model.getAvatarColor() : getColorFallback(vm.model.avc);
  }

  function getColorFallback(val) {
    if (AvatarColors.isColor(val)) {
      return AvatarColors.getColor(val);
    } else {
      return AvatarColors.getColor(getFallbackIndex());
    }
  }

  function getAvatarFontColor() {
    if (vm.model)
      return isFunction(vm.model.getAvatarFontColor) ? vm.model.getAvatarFontColor() : getFontFallback(vm.model.avc);
  }

  function getFontFallback(val) {
    if (AvatarColors.isColor(val)) {
      return AvatarColors.getFontColor(val);
    } else {
      return AvatarColors.getFontColor(getFallbackIndex());
    }
  }

  let fallbackIndex = null;
  function getFallbackIndex() {
    if (fallbackIndex === null) {
      fallbackIndex = AvatarColors.getRand();
    }

    return fallbackIndex;
  }
}



// WEBPACK FOOTER //
// ./src/js/files/directives/AvatarDirective.js